import '../../App.css';
import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';

// SwotTipo (enum backend): Forca=0, Fraqueza=1, Oportunidade=2, Ameaca=3
const TIPO_NOME = { 0: "Forca", 1: "Fraqueza", 2: "Oportunidade", 3: "Ameaca" };
const TIPO_LABEL = { Forca: "Força", Fraqueza: "Fraqueza", Oportunidade: "Oportunidade", Ameaca: "Ameaça" };

function ModalVerSwot({ setModal, capacidade, areaKey, swotTI, onSaved }) {
    const { ObterSwotPorCapacidade, SwotMapaCalor, setSwotMapaCalor, AdicionarSwotPeloMapaCalor, EmpresaKey, setError,
        ListaAreaSwot, AreaSwot } = useContext(ApiContext);
    const { btnVer, btnCriar } = useContext(StyleContext);

    const capacidadeNegocioKey = capacidade?.capacidadeNegocioDemanda?.key;
    const capacidadeTitulo = capacidade?.capacidadeNegocioDemanda?.titulo || "";

    const [carregado, setCarregado] = useState(false);

    // Campos usados apenas no modo de criação
    const [descricao, setDescricao] = useState("");
    const [areaSelecionada, setAreaSelecionada] = useState("");
    const [tipo, setTipo] = useState("");
    const [gravidade, setGravidade] = useState("0");
    const [urgencia, setUrgencia] = useState("0");
    const [tendencia, setTendencia] = useState("0");

    const gut = (Number(gravidade) || 0) * (Number(urgencia) || 0) * (Number(tendencia) || 0);

    // A API retorna três situações:
    // 1) SWOT do ciclo/área existe e a capacidade já está vinculada -> tipo preenchido -> visualização;
    // 2) SWOT do ciclo/área existe mas a capacidade não está vinculada -> tipo nulo -> vincular;
    // 3) nenhuma SWOT para o ciclo/área -> erro "SWOT não encontrada" -> criação.
    const existeSwot = !!SwotMapaCalor?.swot;
    const capacidadeVinculada = existeSwot && SwotMapaCalor?.tipo !== null && SwotMapaCalor?.tipo !== undefined;
    const vincularCapacidade = existeSwot && !capacidadeVinculada;

    useEffect(() => {
        setSwotMapaCalor(null);
        setCarregado(false);
        setAreaSelecionada(areaKey || "");

        ListaAreaSwot();

        if (capacidadeNegocioKey && areaKey) {
            ObterSwotPorCapacidade(areaKey, capacidadeNegocioKey, swotTI).finally(() => setCarregado(true));
        } else {
            setCarregado(true);
        }

        return () => setSwotMapaCalor(null);
    }, [capacidadeNegocioKey, areaKey, swotTI]);

    const fecharModal = () => {
        setSwotMapaCalor(null);
        setModal(false);
    };

    const salvar = () => {
        // No modo de vínculo o nome e a área vêm da SWOT já existente.
        if (!vincularCapacidade) {
            if (!descricao || descricao === "0") {
                setError("Informe o nome do SWOT.");
                setTimeout(() => { setError(""); }, 3000);
                return;
            }
            if (!areaSelecionada || areaSelecionada === "0") {
                setError("Selecione uma área.");
                setTimeout(() => { setError(""); }, 3000);
                return;
            }
        }
        if (!tipo) {
            setError("Selecione o tipo do SWOT.");
            setTimeout(() => { setError(""); }, 3000);
            return;
        }
        if (gravidade === "0") {
            setError("Selecione uma gravidade.");
            setTimeout(() => { setError(""); }, 3000);
            return;
        }
        if (urgencia === "0") {
            setError("Selecione uma urgência.");
            setTimeout(() => { setError(""); }, 3000);
            return;
        }
        if (tendencia === "0") {
            setError("Selecione uma tendência.");
            setTimeout(() => { setError(""); }, 3000);
            return;
        }

        const dados = {
            empresaKey: EmpresaKey,
            swotKey: vincularCapacidade ? SwotMapaCalor?.swot?.key : "",
            descricao: vincularCapacidade ? SwotMapaCalor?.swot?.descricao : descricao,
            areaKey: vincularCapacidade ? (SwotMapaCalor?.swot?.area?.key || areaKey) : areaSelecionada,
            capacidadeNegocioKey: capacidadeNegocioKey,
            gravidade: gravidade,
            urgencia: urgencia,
            tendencia: tendencia,
            tipo: tipo,
            gut: gut,
            swotTI: swotTI,
        };

        AdicionarSwotPeloMapaCalor(dados)
            .then(() => {
                if (onSaved) onSaved();
                fecharModal();
            })
            .catch(() => { });
    };

    // Dados para o modo de visualização (SWOT já existente)
    const tipoNome = typeof SwotMapaCalor?.tipo === "number" ? TIPO_NOME[SwotMapaCalor.tipo] : SwotMapaCalor?.tipo;

    return (
        <div className="modal-criar-demanda">
            <div className="modal-criar-demanda-interno">
                <div className="header-modal-criar-demanda">
                    <div>
                        <h1 className="h1-modal">{swotTI ? "SWOT de TI" : "SWOT"} da capacidade</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => fecharModal()}>
                        <FaTimes />
                    </div>
                </div>
                <form>
                    <div className="modal-content">
                        {!carregado ? (
                            <div style={{ padding: 20 }} className="span-bsc">Carregando...</div>
                        ) : capacidadeVinculada ? (
                            // ---- Modo visualização: a capacidade já está vinculada à SWOT ----
                            <>
                                <Row>
                                    <Col lg={7}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome do SWOT</Form.Label>
                                            <Form.Control maxLength={200} readOnly value={SwotMapaCalor?.swot?.descricao || ""} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.swot?.area?.descricao || ""} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={8}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Capacidade</Form.Label>
                                            <Form.Control maxLength={200} readOnly value={capacidadeTitulo} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ciclo</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.cicloValido?.descricao || ""} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Control readOnly value={TIPO_LABEL[tipoNome] || ""} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.gravidade || ""} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.urgencia || ""} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.tendencia || ""} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.gut ?? ""} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        ) : vincularCapacidade ? (
                            // ---- Modo vínculo: a SWOT do ciclo/área já existe, falta vincular a capacidade ----
                            <>
                                <Row>
                                    <Col lg={7}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome do SWOT</Form.Label>
                                            <Form.Control maxLength={200} readOnly value={SwotMapaCalor?.swot?.descricao || ""} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.swot?.area?.descricao || ""} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={8}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Capacidade</Form.Label>
                                            <Form.Control maxLength={200} readOnly value={capacidadeTitulo} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ciclo</Form.Label>
                                            <Form.Control readOnly value={SwotMapaCalor?.cicloValido?.descricao || ""} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Select value={tipo} onChange={(e) => setTipo(e.target.value)} name="tipo">
                                                <option value="">Selecione</option>
                                                <option value="Forca">Força</option>
                                                <option value="Fraqueza">Fraqueza</option>
                                                <option value="Oportunidade">Oportunidade</option>
                                                <option value="Ameaca">Ameaça</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Select value={gravidade} onChange={(e) => setGravidade(e.target.value)} name="gravidade">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Sem gravidade</option>
                                                <option value={2}>Pouco grave</option>
                                                <option value={3}>Grave</option>
                                                <option value={4}>Muito grave</option>
                                                <option value={5}>Extremamente grave</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Select value={urgencia} onChange={(e) => setUrgencia(e.target.value)} name="urgencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Longuíssimo prazo</option>
                                                <option value={2}>Longo prazo</option>
                                                <option value={3}>Médio prazo</option>
                                                <option value={4}>Curto</option>
                                                <option value={5}>Imediatamente</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Select value={tendencia} onChange={(e) => setTendencia(e.target.value)} name="tendencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Desaparece</option>
                                                <option value={2}>Reduz-se ligeiramente</option>
                                                <option value={3}>Permanece</option>
                                                <option value={4}>Aumenta</option>
                                                <option value={5}>Piora muito</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control readOnly value={gut} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            // ---- Modo criação: não existe SWOT para o ciclo/área ----
                            <>
                                <Row>
                                    <Col lg={7}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome do SWOT</Form.Label>
                                            <Form.Control maxLength={200} value={descricao} onChange={(e) => setDescricao(e.target.value)} name="descricao" />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área</Form.Label>
                                            <Form.Select value={areaSelecionada} onChange={(e) => setAreaSelecionada(e.target.value)} name="areaKey">
                                                <option value="0">Selecione</option>
                                                {AreaSwot?.map((item) => (
                                                    <option key={item.id} value={item.key}>
                                                        {item.descricao}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Capacidade</Form.Label>
                                            <Form.Control maxLength={200} readOnly value={capacidadeTitulo} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Select value={tipo} onChange={(e) => setTipo(e.target.value)} name="tipo">
                                                <option value="">Selecione</option>
                                                <option value="Forca">Força</option>
                                                <option value="Fraqueza">Fraqueza</option>
                                                <option value="Oportunidade">Oportunidade</option>
                                                <option value="Ameaca">Ameaça</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Select value={gravidade} onChange={(e) => setGravidade(e.target.value)} name="gravidade">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Sem gravidade</option>
                                                <option value={2}>Pouco grave</option>
                                                <option value={3}>Grave</option>
                                                <option value={4}>Muito grave</option>
                                                <option value={5}>Extremamente grave</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Select value={urgencia} onChange={(e) => setUrgencia(e.target.value)} name="urgencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Longuíssimo prazo</option>
                                                <option value={2}>Longo prazo</option>
                                                <option value={3}>Médio prazo</option>
                                                <option value={4}>Curto</option>
                                                <option value={5}>Imediatamente</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Select value={tendencia} onChange={(e) => setTendencia(e.target.value)} name="tendencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Desaparece</option>
                                                <option value={2}>Reduz-se ligeiramente</option>
                                                <option value={3}>Permanece</option>
                                                <option value={4}>Aumenta</option>
                                                <option value={5}>Piora muito</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control readOnly value={gut} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => fecharModal()}>
                            {capacidadeVinculada ? "Fechar" : "Cancelar"}
                        </button>
                        {!capacidadeVinculada && carregado &&
                            <button type="button" className="btn-dash btn-criar" style={btnCriar} onClick={() => salvar()}>
                                {vincularCapacidade ? "Vincular" : "Salvar"}
                            </button>
                        }
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ModalVerSwot;
